import { motion } from "framer-motion";
import { darken } from "polished";
import styled from "styled-components";
import { Colors } from "../models/theme";

interface CheckBoxPillProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  color: keyof Colors;
}

const CheckState = styled.div`
  position: relative;
  width: 16px;
  height: 16px;
  background-color white;
  border-radius: 50%;
  margin-right: 8px;
  min-width: 16px;

  &::after {
      content: "";
      display: inline-block;
      height: 16px;
      width: 7px;
      position: absolute;
      top: -4px;
      left: 8px;
      transform: rotate(45deg);
      border-bottom: 2px solid black;
      border-right: 2px solid black;
      opacity: 0;
    }
`;

export const StyledPill = styled(motion.div)<{ color: keyof Colors }>`
  position: relative;
  display: inline-block;
  background-color: ${({ theme, color }) => theme.colors[color]};
  font-weight: 700;
  padding: 0.6rem 1rem;
  border-radius: 100px;
  color: ${({ theme, color }) => theme.colors.blueDark};
  overflow: hidden;

  label {
    display: flex;
    align-items: center;
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    border: 2px solid ${({ theme, color }) => darken(0.1, theme.colors[color])};

    &:checked ~ ${CheckState} {
      background-color: ${({ theme, color }) =>
        darken(0.1, theme.colors[color])};
      &::after {
        opacity: 1;
      }
    }
  }
`;

const InnerFlex = styled.div``;

export const CheckBoxPill: React.FC<CheckBoxPillProps> = ({
  color,
  children,
  ...rest
}) => {
  return (
    <StyledPill
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 1 }}
      color={color}
    >
      <label>
        <input type="checkbox" {...rest}></input>
        <CheckState>{/* <CheckMark /> */}</CheckState>
        {children}
      </label>
    </StyledPill>
  );
};
